/** dataLayer に送る既存 analytics event 名。 */
export const ANALYTICS_EVENTS = {
  PAGE_VIEW: "page_view",
} as const;
